import axios from "axios";

let WI_API_URL;
let PROD_API_URL;
let VALIDATE_API_URL;
let WPQ_Linking_API_URL;
let GROOVE_API_URL;

if (process.env.REACT_APP_NODE_ENV === "local") {
  WI_API_URL = process.env.REACT_APP_WI_API_URL;
  PROD_API_URL = process.env.REACT_APP_PROD_API_URL;
  VALIDATE_API_URL = process.env.REACT_APP_VALID_API_URL;
  WPQ_Linking_API_URL = process.env.REACT_APP_LINKING_API_URL;
  GROOVE_API_URL = process.env.REACT_APP_WPQ_GROOVE_API_URL

} else {
  WI_API_URL = process.env.REACT_APP_API_URL + "wi";
  PROD_API_URL = process.env.REACT_APP_API_URL + "wi/prod";
  VALIDATE_API_URL = process.env.REACT_APP_API_URL + "wi/wiValidate";
  WPQ_Linking_API_URL = process.env.REACT_APP_API_URL + "wi/wpqlinking";
  GROOVE_API_URL = process.env.REACT_APP_API_URL + "wpq";
}

//get ALL WI Slip for 24 hrs uses local secondary index
//USED in WI dashboard

export async function getallwelders() {
  try {
    const response = await axios.get(WI_API_URL + "/getallWelder");
    return response.data;
  } catch (error) {
    console.log("Unable to find request", error);
  }
}

//Welders from from welding continuity table
//USED in WCR report for getting all welders who's alip has been generated
//Continuity table has Welder process wise, with his last weld record
//Same process category if teh welder has welded 3 times then then his
//last welding will be stored here

export async function getwiwelders() {
  let url = `${WI_API_URL}/getwidata/excel`;
  const response = await axios.get(url).then(function (resp) {
    return resp;
  })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
}

//get welders from WI based on project and joint
// used in list of welders,prod report,welder record sheet
export const getWIdataexcelbyProjectno = async (projectNumber, jointNumber) => {
  let reqbody = { PK: projectNumber, SK: jointNumber }
  let url = `${WI_API_URL}/getWIdataexcelbyProjectno/excel`;
  const response = await axios.post(url, reqbody)
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};

/* export async function getwiwelderswcr() {
  let url = `${WI_API_URL}/getwidata/wcr/excel`;
  const response = await axios.get(url)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
} */


/**
 * 
 * @param {*} id 
 * @returns 
 * Data based on SLIP id
 */
export async function getallWelderid(id) {
  let url = `${WI_API_URL}/getallWelderid`;
  let reqbody = { ID: id }
  const response = await axios.post(url, reqbody)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
}
/**
 * 
 * @returns 
 * last SLip id from SK - WIRequestCount
 * updated WIRequestCount on SLIP generation to +1
 */
export async function getCount() {
  const response = await axios.get(WI_API_URL + "/getcount")
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
}
/**
 * 
 * @param {
 * } welder 
 * @returns 
 * 
 * 1. ADDs WELDER SLIP
 * 2. ADD in continuity table for a welder,process category this always has 
 * last weld date as SK "welderis#processcategory#type" is overwritted everytime
 * mew slip for welder is created for same processcategory and type, this is used in 
 * last weld date report in wel continuity
 * 
 * 3. Project number and joint number in Welding_wi_mst table this is used to get all
 * project numbers and joint numbers for which slip is created. PK - PROJECT_NO,
 * SK - "proectid", joint number is array uses dynamo db String set to add array joints
 */
export const addwelder = async (welder) => {
  let url = `${WI_API_URL}/addwelder`;
  const response = await axios.post(url, welder)
    .then(function (resp) {
      return resp.data;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response;
};

/// updates reprint and print date
export const UpdateSlip = async (row) => {
  let url = `${WI_API_URL}/updateslip`;
  const response = await axios.post(url, row)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};

/// cancels a SLIP upadtes WI based on slip number
export const CancelSlip = async (slip) => {
  let url = `${WI_API_URL}/cancelslip`;
  const response = await axios.post(url, slip)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};

/// deletes a SLIP upadtes WI based on slip number
export const DeleteSlip = async (slip) => {
  let url = `${WI_API_URL}/deleteslip`;
  const response = await axios.post(url, slip)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};

//Used in list of welder and Welder record sheet - supports pagination
export async function WIexportreport(wi, options = {}) {
  let url = `${WI_API_URL}/exportreport`;
  const { paginated = false, limit = 1000, lastKey = null } = options;

  const requestBody = {
    ...wi,
    paginated,
    limit,
    lastKey
  };

  const resp = await axios.post(url, requestBody)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      console.error('Error in WIexportreport:', error);
      throw error;
    });
  return resp;
}


export async function WCRexportreport(wi) {
  let url = `${WI_API_URL}/WCRexportreport`;
  const resp = await axios.post(url, wi)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.message;
    });
  return resp;
}

export async function getLastWeldDate(wi) {
  let url = `${WI_API_URL}/getlatestwelddate`;
  const resp = await axios.post(url, wi)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.message;
    });
  return resp;
}

export async function getAllOnlySlipNos() {
  const response = await axios.get(PROD_API_URL + "/getAllSlipNos")
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
}

export async function getWIDataHeader(wiheader) {
  let url = `${PROD_API_URL}/slipNo`;
  const resp = await axios.post(url, wiheader)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.message;
    });

  return resp;
}

export const addNewProductivity = async (prodMeasure) => {
  let url = `${PROD_API_URL}/addNewProductivity`;
  const response = await axios
    .post(url, prodMeasure)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};

export async function PRODexportreport(wi) {
  let url = `${PROD_API_URL}/exportreportPROD`;
  const resp = await axios.post(url, wi)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.message;
    });
  return resp;
}

//Gets details of a prod measure
export async function getProdMeasure(slipId) {
  let url = `${PROD_API_URL}/slipId`;
  const resp = await axios.post(url, slipId)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.message;
    });
  return resp;
}

export async function checkJointNoPresent(gridDetail) {
  let url = `${VALIDATE_API_URL}/checkJointNo`;
  const resp = await axios.post(url, gridDetail)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.message;
    });
  return resp;
}

/* export async function getForFilters() {
  let url = `${WI_API_URL}/getForFilters/inReport`;
  const response = await axios.get(url)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
}
 */
export const addwpqlink = async (link) => {
  let dataObj = { "data": link }
  let url = `${WPQ_Linking_API_URL}/addwpqlinking`;
  const response = await axios.post(url, dataObj)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};

export async function getwpqlink(flag, projectNumber = "") {
  let url = `${WPQ_Linking_API_URL}/getlinking`;
  let dataobj = {
    "projectNumber": projectNumber,
    "npcilflag": flag
  }
  const response = await axios.post(url, dataobj)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
}

export async function linkbyproject(link) {
  let url = `${WPQ_Linking_API_URL}/link/project`;
  const resp = await axios.post(url, link)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.message;
    });
  return resp;
}


export async function getProjectLinkWPQByType(dataObj) {
  let url = `${WPQ_Linking_API_URL}/link/byjointtype`;
  const resp = await axios.post(url, dataObj).then(function (response) {
    return response.data;
  }).catch(function (error) {
    return error.message;
  });
  return resp;
}

/* export async function getAllWiProjects() {
  let url = `${WI_API_URL}/getAllWiProjects`;
  const response = await axios.get(url)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
} */

///Gets all processs for a joint
//used in welding analysis uses WLEDREPORT GSI
export async function getWIweldingprocess(projectNumber, jointNumber) {
  let keyObj = {
    projectNumber: projectNumber,
    jointNumber: jointNumber
  }
  let url = `${WI_API_URL}/getWiWeldingProcessProjectJointWise`;
  const response = await axios.post(url, keyObj)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
}

/**
 * 
 * @param {*} projectNumber 
 * @param {*} jointNumber 
 * @param {*} processNumber 
 * @returns 
 * Process wise welding numbers for a joint. uses Weldreport GSI 
 * used in welding analysis
 */
export async function getWiWeldingNumbersProjJointProcessWise(projectNumber, jointNumber, processNumber) {
  let keyObj = {
    projectNumber: projectNumber,
    jointNumber: jointNumber,
    processNumber: processNumber
  }

  let url = `${WI_API_URL}/getWiWeldingNumbersProjJointProcessWise`;
  const response = await axios.post(url, keyObj)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
}

// The WI table has PK "Proejct_No" where project number and joint number used
// by WI is maintained, this is added when a WI is added.
// A entry for project number and corrosponding joint number and count of times WI is
// generated for that joint number is maintained in this table.
// This function is used to get the count of times WI is generated for a joint number
// in a project.
export async function getWIReqCount(ReqCount) {
  let url = `${WI_API_URL}/getJointNumbersLength`;
  let reqbody = { Project: ReqCount }
  const response = await axios.post(url, reqbody)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
}

/* export async function getWIReqCountByProjectNo(ReqCount) {
  let url = `${WI_API_URL}/getJointNumbersLengthByProjectNo`;
  let reqbody = { Project: ReqCount }
  const response = await axios.post(url, reqbody)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
} */
/**
 * 
 *  This also uses PK "Project_no" saved during WI slip generation
 */
export async function getListofProjectno() {
  const response = await axios.get(WI_API_URL + "/getListofProjectno")
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
}

export async function getWpqNpcilLink() {
  let url = `${WPQ_Linking_API_URL}/getNpcilLinking`;
  const response = await axios.post(url)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
}

export async function getWpqNpcilLinkByProjectNumber(dataObj) {
  let url = `${WPQ_Linking_API_URL}/getWpqNpcilLinkByProjectNumber`;
  const response = await axios.post(url, dataObj)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
}

export async function getWpqNpcilLinkByProjNoJointType(data) {
  let url = `${WPQ_Linking_API_URL}/getWpqNpcilLinkByProjNoJointType`;
  const response = await axios.post(url, data)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
}

export const addNpcilWpqLink = async (link, flag) => {
  let dataObj = { "data": link, "deleteLinksFlg": flag }
  let url = `${WPQ_Linking_API_URL}/addNpcilWpqLink`;
  const response = await axios.post(url, dataObj)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};

export const addWPQLinkingRecord = async (dataObj) => {
  let url = `${WPQ_Linking_API_URL}/addWPQLinkingRecord`;
  const response = await axios.post(url, dataObj)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};

export const deleteNpcilWpqLink = async (PK, SK) => {
  let dataObj = { "PK": PK, "SK": SK }
  let url = `${WPQ_Linking_API_URL}/deleteNpcilWpqLink`;
  const response = await axios.post(url, dataObj)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};

export const getNpcilByPKSK = async (dataObj) => {
  let url = `${WPQ_Linking_API_URL}/getNpcilByPKSK`;
  const response = await axios.post(url, dataObj)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};

export const getLinkedWPQBySK = async (dataObj) => {
  let url = `${GROOVE_API_URL}/WpqHeaderMast/getLinkedWPQBySK`;
  const response = await axios.post(url, dataObj)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};

export const getWPQLinkingRecords = async (dataObj) => {
  let url = `${WPQ_Linking_API_URL}/getWPQLinkingRecords`;
  const response = await axios.post(url, dataObj)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};

export const checkWPQProjectLinking = async (wpqWelderId, wpqRecordNo) => {
  let url = `${WPQ_Linking_API_URL}/checkWPQProjectLinking`;
  const response = await axios.post(url, { wpqWelderId, wpqRecordNo })
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};

export const checkWpqNpcilLinking = async (body) => {
  let url = `${WPQ_Linking_API_URL}/check-wpq-npcil-linking`;
  const response = await axios.post(url, body)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};
export const getWIBySlipNumber = async (slipNumber) => {
  let url = `${WI_API_URL}/getbyslipnumber`;
  const response = await axios
    .post(url, { slipNumber })
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};
export const checkProjectLinkingByPKSK = async (PK, SK) => {
  let url = `${WPQ_Linking_API_URL}/check-project-linking-by-pk-sk`;
  const response = await axios.post(url, { PK, SK })
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};